import { cn } from "../foundations/cn.js";

export interface SkeletonProps {
  /** Size and radius classes for the shape it stands in for: `h-5 w-32 rounded-sm`. */
  className?: string;
}

/**
 * A placeholder for content still loading, sized like it so nothing shifts when it lands. It
 * pulses by opacity, and holds still under reduced motion.
 */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn("rounded-md bg-bg-raised motion-safe:animate-pulse", className)}
    />
  );
}
